import BaseService from "./BaseService";
import { camelizeKeys } from "humps";

const objectType = "sra-options";

class SraOptionsService extends BaseService {
  static getList() {
    return super
      .get("lookup/sra_options")
      .then((response) => {
        return Promise.resolve(camelizeKeys(response.data));
      })
      .catch((error) => {
        return Promise.reject(error.response.data);
      });
  }

  static create(data) {
    return super
      .post(objectType, `lookup/sra_options`, data)
      .then((response) => {
        return Promise.resolve(camelizeKeys(response.data.data));
      })
      .catch((error) => {
        return Promise.reject(error.response.data.errors[0].detail);
      });
  }

  static update(data) {
    return super
      .patch(objectType, `lookup/sra_options/${data.id}`, data)
      .then((response) => {
        return Promise.resolve(camelizeKeys(response.data.data));
      })
      .catch((error) => {
        return Promise.reject(error.response.data.errors[0].detail);
      });
  }

  static delete(id) {
    return super
      .delete(`lookup/sra_options/${id}`)
      .then((response) => {
        return Promise.resolve({ id });
      })
      .catch((error) => {
        return Promise.reject(error.response.data);
      });
  }
}

export default SraOptionsService;
